import axios from 'axios'
// import { ToastProgrammatic as Toast } from 'buefy'
import { LoadingProgrammatic as Loading } from 'buefy'
import { DialogProgrammatic as Dialog } from 'buefy'

const baseURL = process.env.VUE_APP_BASE_URL;

const state = {
    categories: []
}

const getters = {
    allCategories: (state) => {
        return state.categories
    },
    categoryName: (state) => (id) => {
        for (let cat in state.categories) {
            if (state.categories[cat]._id === id) {
                return state.categories[cat].name
            }
        }
    }
}

const actions = {
    async fetchCategories({ commit, rootState }) {
        const loading = Loading.open()
        try {
            const response = await axios.get(`${baseURL}/categories/getAll`, {
                headers: {
                    'Authorization': rootState.user.authHeader
                }
            })
            commit('setCategories', response.data)
        } catch (error) {
            // console.log(error)
        } finally {
            loading.close()
        }
    },
    async addCategory({ commit, rootState }, payload) {
        const loading = Loading.open()
        try {
            if (payload.formData) {
                const resp = await axios.post(`${baseURL}/upload/uploadBackgroundCategory`, payload.formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': rootState.user.authHeader
                    }
                })
                // var id = payload._id
                // var url = resp.data.url
                // commit('updatedCategoryBackground', { id, url })
                if (resp.data.success) {
                    const response = await axios.post(`${baseURL}/categories/addCategory`, {
                        name: payload.name,
                        backgroundUrl: resp.data.url
                    }, {
                        headers: {
                            'Authorization': rootState.user.authHeader
                        }
                    })
                    commit('newCategory', response.data)
                    loading.close()
                    Dialog.alert({
                        title: 'Success',
                        message: 'Category is added successfully.',
                        confirmText: 'Ok!',
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa'
                    })
                }
            } else {
                const response = await axios.post(`${baseURL}/categories/addCategory`, {
                    name: payload.name,
                    backgroundUrl: null
                }, {
                    headers: {
                        'Authorization': rootState.user.authHeader
                    }
                })
                commit('newCategory', response.data)
                loading.close()
                Dialog.alert({
                    title: 'Success',
                    message: 'Category is added successfully.',
                    confirmText: 'Ok!',
                    type: 'is-success',
                    hasIcon: true,
                    icon: 'check-circle',
                    iconPack: 'fa'
                })
            }
        } catch (error) {
            loading.close()
            Dialog.alert({
                title: 'Error',
                message: 'An error occured while trying to add category.',
                confirmText: 'Ok!',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa'
            })
        }
    },
    async editCategory({ commit, rootState }, payload) {
        const loading = Loading.open()
        try {
            if (payload.formData) {
                const resp = await axios.post(`${baseURL}/upload/uploadBackgroundCategory`, payload.formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': rootState.user.authHeader
                    }
                })
                // console.log(resp.data, 'response data')
                // var id = payload._id
                // var url = resp.data.url
                // commit('updatedCategoryBackground', { id, url })
                if (resp.data.success) {
                    const response = await axios.put(`${baseURL}/categories/update?userId=XXXYYYZZZ&id=${payload._id}`, 
                        {
                            name: payload.name,
                            backgroundUrl: resp.data.url
                        },
                        { 
                            headers: {
                                'Authorization': rootState.user.authHeader
                            }
                        })
                    // console.log(payload.formData, 'form data')
                    commit('updatedCategory', response.data)
                    loading.close()
                    Dialog.alert({
                        title: 'Success',
                        message: 'Category is updated successfully.',
                        confirmText: 'Ok!',
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa'
                    })
                }
            } else {
                const response = await axios.put(`${baseURL}/categories/update?userId=XXXYYYZZZ&id=${payload._id}`, 
                    {
                        name: payload.name,
                        backgroundUrl: payload.backgroundUrl
                    }, { 
                        headers: {
                            'Authorization': rootState.user.authHeader
                        }
                    })
                commit('updatedCategory', response.data)
                loading.close()
                Dialog.alert({
                    title: 'Success',
                    message: 'Category is updated successfully.',
                    confirmText: 'Ok!',
                    type: 'is-success',
                    hasIcon: true,
                    icon: 'check-circle',
                    iconPack: 'fa'
                })
            }
        } catch (error) {
            loading.close()
            Dialog.alert({
                title: 'Error',
                message: 'An error occured while trying to edit category.',
                confirmText: 'Ok!',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa'
            })
        }
    },
    async deleteCategory({ commit, rootState }, id) {
        const loading = Loading.open()
        try {
            await axios.delete(`${baseURL}/categories/delete?userId=XXXYYYZZZ&id=${id}`, {
                headers: {
                    'Authorization': rootState.user.authHeader
                }
            })
            commit('delCategory', id)
            loading.close()
            Dialog.alert({
                title: 'Success',
                message: 'Category is deleted successfully.',
                confirmText: 'Ok!',
                type: 'is-success',
                hasIcon: true,
                icon: 'check-circle',
                iconPack: 'fa'
            })
        } catch (error) {
            loading.close()
            Dialog.alert({
                title: 'Error',
                message: 'An error occured while trying to delete category.',
                confirmText: 'Ok!',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa'
            })
        }
    },
}

const mutations = {
    setCategories: (state, categories) => (state.categories = categories),
    newCategory: (state, category) => (state.categories.push(category)),
    delCategory: (state, id) => (state.categories = state.categories.filter(cat => cat._id !== id)),
    updatedCategory: (state, updCategory) => {
        const index = state.categories.findIndex(cat => cat._id === updCategory._id)
        if (index !== -1) {
            state.categories.splice(index, 1, updCategory)
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}